import styled from 'styled-components';

export const TableConsultBillingsMonthStyle = styled.table`
  box-sizing: border-box;
  border-collapse: collapse;
  width: 100%;
  background-color: ${({ theme }) => {
    return theme.colors.white;
  }};
  color: ${({ theme }) => {
    return theme.colors.white;
  }};
  border: none;
  font-size: ${({ theme }) => {
    return theme.fonts.size.normal;
  }};
  font-weight: ${({ theme }) => {
    return theme.fonts.weight.thin;
  }};
  th {
    font-size: ${({ theme }) => {
      return theme.fonts.size.normal;
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.thin;
    }};
    border: ${({ theme }) => {
      return theme.border;
    }};
    background-color: ${({ theme }) => {
      return theme.colors.darkPrimary;
    }};
  }
  td {
    text-align: center;
    border: ${({ theme }) => {
      return theme.border;
    }};
    color: ${({ theme }) => {
      return theme.colors.black;
    }};
    background-color: ${({ theme }) => {
      return theme.colors.white;
    }};
  }
  p {
    margin: 10px 0;
  }
  .complete {
    background-color: ${({ theme }) => {
      return theme.colors.card_complete;
    }};
  }
  .incomplete {
    background-color: ${({ theme }) => {
      return theme.colors.card_incomplete;
    }};
  }
`;
